import { css } from 'lit';
import componentStyles from '../styles/component.styles';
import blockStyles from '../styles/block.styles';
export default css `
  ${componentStyles}
  ${blockStyles}
  /**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
    display: block;
    background-color: var(--p-section-bg);
  }

  :host([dark]) {
    --p-section-bg: var(--p-bg-dark);
    --p-text-color: var(--p-text-color-light);
  }

  :host([preview]) {
    outline: 2px dashed var(--p-border, #e1e3e8);
    outline-offset: -2px;
  }

  .live-banner {
    border-bottom: 1px solid var(--p-border);
  }

  .live-banner.preview-mode {
    position: relative;
  }

  .live-banner .section-label {
    position: absolute;
    bottom: 3px;
    right: 3px;
    background: #fff;
    color: #333840;
    line-height: 1;
    font-weight: 600;
    font-size: 0.75rem;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid #d5d7db;
    border-radius: 4px 0 0 0;
    padding: 4px 7px;
    z-index: 1;
    display: inline-block;
    font-family: system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
      'Segoe UI Emoji';
  }

  .live-banner ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: grid;
    grid-template-columns: auto 1fr;
    column-gap: 0.75rem;

    li {
      display: grid;
      grid-template-columns: subgrid;
      grid-column: 1 / -1;
    }
  }

  /**
--------------------------------------------------
* Text align
--------------------------------------------------
*/

  a {
    cursor: pointer;
    color: var(--p-link-text-color);
    text-decoration: none;
  }

  a:hover {
    color: var(--p-link-text-color-hover);
    text-decoration: var(--p-link-text-decoration-hover);
  }

  /**
--------------------------------------------------
* Banner
--------------------------------------------------
*/
  .banner-inner {
    padding-inline: var(--p-gap);
    grid-template-columns: subgrid;
    display: grid;
    grid-column: 1 / -1;
  }

  .contained ul,
  .contained .banner-inner {
    width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
    margin-inline: auto;
    padding-inline: 0;
  }

  .banner.upcoming .banner-inner {
    display: grid;
    grid-template-columns: subgrid;
    column-gap: 0.75rem;
    row-gap: 0.25rem;
    font-size: 0.875rem;
    color: var(--p-text-color);
    text-decoration: none;
  }

  .banner.upcoming h2 {
    font-family: var(--p-h6-font);
    font-size: var(--p-h6-font-size);
    font-weight: var(--p-h6-font-weight);
    font-style: var(--p-h6-font-style);
    line-height: 1;
    text-transform: var(--p-h6-transform);
    letter-spacing: var(--p-h6-letter-spacing);
    margin: 0;
    max-width: 530px;
    color: var(--p-link-text-color);
    text-decoration: var(--p-link-text-decoration);
  }

  .banner.upcoming a:hover h2,
  .banner.upcoming a:focus-within h2 {
    text-decoration: var(--p-link-text-decoration-hover);
    color: var(--p-link-text-color-hover);
  }

  .banner {
    padding-block: 0.25rem;
  }

  .banner:first-of-type {
    padding-top: 0.75rem;
  }

  .banner:last-of-type {
    padding-bottom: 0.75rem;
  }

  .banner.live {
    margin-bottom: 0.1rem;
  }

  .banner .live-badge {
    top: 3px;
    left: 3px;
  }

  /**
--------------------------------------------------
* Preview
--------------------------------------------------
*/
  .preview {
    outline: 3px dashed #e1e3e8;
    outline-offset: -10px;
    padding: 20px 0;
  }

  .preview .banner {
    border: 0 !important;
  }
`;
